import React, { createContext, useContext, useState, useCallback } from 'react';

const PlayerPopupContext = createContext(null);

export function PlayerPopupProvider({ children }) {
  const [popup, setPopup] = useState(null); // { userId, x, y }

  const openPopup = useCallback((userId, x, y) => {
    setPopup(prev =>
      prev && String(prev.userId) === String(userId) ? null : { userId, x, y }
    );
  }, []);

  const closePopup = useCallback(() => setPopup(null), []);

  return (
    <PlayerPopupContext.Provider value={{ popup, openPopup, closePopup }}>
      {children}
    </PlayerPopupContext.Provider>
  );
}

export function usePlayerPopup() {
  return useContext(PlayerPopupContext);
}
